import { CallStage, useCallStateContext } from 'app/containers/call/CallStateContext';
import { useBookingInterface } from 'app/containers/rtc/BookingContext';
import { useBookingState } from 'app/containers/rtc/BookingContext/BookingState';
import { usePeers } from 'app/containers/rtc/PeersContext';
import { BookingType, BookingTypeSettings, CallEndReason } from 'app/models/rtc/booking/constants';
import React, { useEffect } from 'react';
import { idleCallHandler } from 'app/utils/idle';

/**
 * Determines whether or not a booking should handle idle disconnect.
 */
export const shouldCallIdleDisconnect = (bookingType: BookingType, callStage: CallStage, peerSize: number): boolean => {
  switch (bookingType) {
    case BookingType.Lesson:
      return callStage === CallStage.PostLocked;
    case BookingType.Meeting:
      // If a user is the only participant in the room then there are 0 peers
      return peerSize === 0;
    case BookingType.TeacherRegistration:
    case BookingType.TestCall:
      return false;
  }
};

const IdleDisconnectTrigger: React.FunctionComponent = () => {
  const bookingState = useBookingState();
  const peers = usePeers();
  const { clearActiveBooking } = useBookingInterface();
  const { stage } = useCallStateContext();

  const bookingType = bookingState?.bookingType;
  const callIdleDisconnect =
    bookingType !== undefined ? shouldCallIdleDisconnect(bookingType, stage, peers.size) : false;

  useEffect(() => {
    if (callIdleDisconnect === true && bookingType !== undefined) {
      const idleDisconnectTime = BookingTypeSettings[bookingType].idleDisconnectTime;
      return idleCallHandler(idleDisconnectTime, () => clearActiveBooking(CallEndReason.Idle));
    }
  }, [clearActiveBooking, bookingType, callIdleDisconnect]);

  return null;
};

export default IdleDisconnectTrigger;
